import MenuHorizontalIcon from '@assets/icons/menu-horizontal.svg';
import React from 'react';
import { Button } from '@/components/button';
import { CollectionOptionType } from '@/hooks/use-collection-list-options';
import { GestureHandlerRootView } from 'react-native-gesture-handler';
import {
  LIST_ITEM_VERTICAL_PADDING,
  ListItemSeparator,
} from '@/components/list-item';
import { OrderGuideCollectionListItemContent } from './order-guide-collection-list-item-content';
import { SIZES } from '@/components/circled-icon';
import { SortableList } from '@/components/sortable-list';
import { StyleSheet, View } from 'react-native';
import { useLayoutContext } from '@/contexts/layout-context';

const PLACEHOLDER_HEIGHT = SIZES.small + 2 * LIST_ITEM_VERTICAL_PADDING;

interface Props {
  collectionData: CollectionOptionType[];
  onCollectionOrderChange: (collectionList: CollectionOptionType[]) => void;
  onEditPress: (collection: CollectionOptionType) => void;
}

export const EditableCollectionsList: React.FC<Props> = ({
  onCollectionOrderChange,
  onEditPress,
  collectionData,
}) => {
  const { isSmallLayout } = useLayoutContext();
  return (
    <GestureHandlerRootView style={styles.containerFix}>
      <SortableList<CollectionOptionType>
        containerStyle={styles.containerFix}
        isDragHidden={collectionData.length === 1}
        items={collectionData}
        ListFooterComponent={
          isSmallLayout
            ? () => (
                <>
                  <ListItemSeparator />
                  <View style={styles.footerPlaceholder} />
                </>
              )
            : undefined
        }
        onChange={(collections) => {
          onCollectionOrderChange(collections);
        }}
        renderInPortal={false}
        renderItemContent={(item) => (
          <View style={styles.content}>
            <OrderGuideCollectionListItemContent option={item} />
            {!item.metadata?.isLocked ? (
              <Button
                Icon={MenuHorizontalIcon}
                onPress={() => {
                  onEditPress(item);
                }}
                size="xsmall"
                style={styles.menuButton}
                testID="edit-collection-menu-button"
                trackingData={{
                  name: 'edit_collection.menu_button',
                  properties: {
                    collectionUUID: item.value,
                  },
                }}
                type="tertiary"
              />
            ) : null}
          </View>
        )}
      />
    </GestureHandlerRootView>
  );
};

const styles = StyleSheet.create({
  containerFix: {
    flex: -1,
  },
  content: {
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingVertical: LIST_ITEM_VERTICAL_PADDING,
  },
  footerPlaceholder: {
    height: PLACEHOLDER_HEIGHT,
  },
  menuButton: {
    paddingRight: 4,
  },
});
